import { createContext } from "react";

import { flagg } from "../core";
import { inMemoryStore } from "../store";

export const FlaggContext = createContext({
  featureFlags: flagg({ store: inMemoryStore() }),
  iteration: 0,
});
